/**
 * QBase 점검(쓰기 동결) 배너 — 「큐베이스 점검 중 — 조회만 가능합니다」 (2026-11-02).
 *
 * QBase 가 DB 를 옮기는 동안 쓰기를 막는다. 그동안 저장이 이유 없이 실패하는 것처럼 보이지 않게 화면 맨 위에 알린다.
 * 상태는 services/qbaseMaintenance 한 곳이 정하고(응답 헤더 · 503 MAINTENANCE · 주기 확인), 여기는 그리기만 한다.
 * active=false 가 오면 저절로 사라진다. 전환 마지막의 재기동(접속 거부) 동안은 「DB 전환 중, 곧 돌아옵니다」 로 바뀐다.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import useQbaseMaintenance from '../hooks/useQbaseMaintenance';
import './QbaseMaintenanceBanner.css';

/** 자동 해제 시각 — 알아볼 수 없는 값이면 빈 문자열(문구에서 뺀다) */
function formatTime(v, lang) {
    if (!v) return '';
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return '';
    const sameDay = d.toDateString() === new Date().toDateString();
    return sameDay
        ? d.toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit' })
        : d.toLocaleString(lang, { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function QbaseMaintenanceBanner() {
    const { t, i18n } = useTranslation();
    const m = useQbaseMaintenance();
    if (!m || !m.active) return null;

    const until = formatTime(m.expiresAt, i18n.language);
    const detail = [m.message, until ? t('common:qbMaint.until', { time: until }) : ''].filter(Boolean).join(', ');
    const text = m.restarting
        ? t('common:qbMaint.restarting')
        : (detail ? t('common:qbMaint.bannerWithDetail', { detail }) : t('common:qbMaint.banner'));

    return (
        <div className="qbase-maint-banner" role="status" aria-live="polite">
            <span className="qbase-maint-dot" aria-hidden="true" />
            <span>{text}</span>
        </div>
    );
}
